import { WatchingOptionType } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { IntlShape } from 'react-intl';

export const dictionary = {
    card__top10: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.selections.a15b2b975becae8c315e9bf80e0ef661',
            defaultMessage: 'Top 10',
            description: 'Заголовок бейджа Топ-10',
        }),
    card__purchasable: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.selections.ec210d41bd962f9c46784fd48b69a1d6',
            defaultMessage: 'Purchasable',
            description:
                'aria-label attribute for "Purchasable" badge on selection card (for purchasable titles)',
        }),
    card__planned_to_watch: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.FavoriteBadge.e08642d46f86477b5e08d0b692c27e28',
            defaultMessage: 'Watch later',
            description: 'Атрибут aria-label для бейджа "Буду смотреть" на карточке тайтла',
        }),
    card__season_announce: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.358c33416986f65230ae43f65367a8bc',
            defaultMessage: 'new season',
            description: 'Текст для анонса нового сезона',
        }),
    card__waiting_unwatchable: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.Card.453e6aa38d87b28ccae545967c53004f',
            defaultMessage: 'Unavailable',
            description: 'Текст бейджа для недоступного эпизода',
        }),
    card__expired: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'shared.i18n.ab0bda9ad2f3a626ac460177b32484a3',
            defaultMessage: 'Lease expired',
            description: 'Текст бейджа для просроченного фильма',
        }),
    card__starts_in: (intl: IntlShape, { value }: { value: string }) =>
        intl.formatMessage(
            {
                id: 'shared.i18n.91cf8104921bc569c70075cc46b5cf4c',
                defaultMessage: 'in {value}',
                description: 'Время до начала телепередачи',
            },
            {
                value,
            }
        ),
    card__time_left: (intl: IntlShape, { value }: { value: string }) =>
        intl.formatMessage(
            {
                id: 'shared.i18n.0dbf93200127629505eb63e833d345ac',
                defaultMessage: '{value} left',
                description: 'Время до конца телепередачи',
            },
            {
                value,
            }
        ),
    error__title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.navigation.d0fbda9855d118740f1105334305c126',
            defaultMessage: 'Page not found',
            description: 'Подпись ошибки, если был переход на несуществующую страницу',
        }),
    error__description: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.navigation.7db66a42bb515f3ce685bb5e5119de0c',
            defaultMessage: 'It may have been moved, or the page address might be incorrect',
            description: 'Пояснение к ошибке, если был переход на несуществующую страницу',
        }),
    error__server_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.navigation.731e024ead4b1b6cdedeb8e74373c451',
            defaultMessage: 'Server error',
            description: 'Подпись ошибки, если произошла ошибка сервера',
        }),
    error__server_description: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.navigation.0082405b2d6ae16e9e3be0912e56b1a7',
            defaultMessage: 'The website is currently unavailable. Try again later.',
            description: 'Пояснение к ошибке, если произошла ошибка сервера',
        }),
    error__refresh_page: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.navigation.5b7ae750cd57d8ce894a3152aadbb4e3',
            defaultMessage: 'Refresh the page',
            description: 'Кнопка обновления страницы на странице ошибки',
        }),
    announce__promise__soon: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.b5ccb7d52b4f221253779a94cd40e902',
            defaultMessage: 'Soon',
            description: 'Текст для анонса "Скоро"',
        }),
    announce__promise__summer: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.89b860779dc5e269f17da915a10a2c45',
            defaultMessage: 'this summer',
            description: 'Текст для анонса "этим летом"',
        }),
    announce__promise__autumn: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.020ce10a9d9f481307a129af90dabd7e',
            defaultMessage: 'this fall',
            description: 'Текст для анонса "этой осенью"',
        }),
    announce__promise__winter: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.860423c4b0eb102ad646648865f100a9',
            defaultMessage: 'this winter',
            description: 'Текст для анонса "этой зимой"',
        }),
    announce__promise__spring: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.f66c3c3f785eed9bdcd93cd131a61ff3',
            defaultMessage: 'this spring',
            description: 'Текст для анонса "этой весной"',
        }),
    announce__new_season: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.358c33416986f65230ae43f65367a8bc',
            defaultMessage: 'new season',
            description: 'Текст для анонса нового сезона',
        }),
    announce_promise__subscription: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.97a3c4d232ebb12d4971b48c5efdcfe3',
            defaultMessage: 'in subscription',
            description: 'Текст для анонса "в подписке"',
        }),
    announce_promise__date: (
        intl: IntlShape,
        {
            watchingOptionType,
            day,
            month,
        }: { watchingOptionType: WatchingOptionType; day: number; month: string }
    ) =>
        intl.formatMessage(
            {
                id: 'features.movie.957e1f05ccd18e973cbd6062449abaa6',
                defaultMessage:
                    '{watchingOptionType, select, SUBSCRIPTION {In your subscription} PAID {In the store} PAID_MULTIPLE {In the store} other {}} starting {month} {day, select, undefined {} other {{day} }}',
                description:
                    'Текст для анонса с датой, где watchingOptionType — доступность просмотра',
            },
            {
                watchingOptionType,
                day,
                month,
            }
        ),

    expiration_less_left_time: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'common.ott.entities.filmPurchase.d69f265ea27772294d467d9ce2f7c976',
            defaultMessage: 'Less than an hour',
            description: 'Текст о том, что осталось меньше часа до завершения аренды фильма',
        }),
    expiration_start_watch: (intl: IntlShape, { time }: { time: string }) =>
        intl.formatMessage(
            {
                id: 'common.ott.entities.filmPurchase.f122a6972d69212cc5301422383c2430',
                defaultMessage: '{time} to start watching',
                description: 'Текст о том, когда можно начать просмотр фильма',
            },
            { time }
        ),
    expiration_end_watch: (intl: IntlShape, { periodText }: { periodText: string }) =>
        intl.formatMessage(
            {
                id: 'common.ott.entities.filmPurchase.90484360692e135e735e1b773a1d69a5',
                defaultMessage: '{periodText} to finish watching',
                description: 'Текст о том, сколько осталось до завершения просмотра фильма',
            },
            { periodText }
        ),
    season_and_series: (
        intl: IntlShape,
        { seasonNumber, episodeNumber }: { seasonNumber: number; episodeNumber: number }
    ) =>
        intl.formatMessage(
            {
                id: 'features.selection.86300b232234c7c00bab5b6e853a81d3',
                defaultMessage: 'Season {seasonNumber}, Episode {episodeNumber}',
                description: 'Подзаголовок карточки с номером эпизода и серии',
            },
            { seasonNumber, episodeNumber }
        ),
    card__show_all: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.SelectionListItems.eb92025cb8c66f1850c13a9b602a1856',
            defaultMessage: 'Show all',
            description: 'Текст ссылки на страницу с фильмами',
        }),
    continue_watching__remove_button__label: (intl: IntlShape, { title }: { title: string }) =>
        intl.formatMessage(
            {
                id: 'features.selections.b62be6f87e1d936fd9027acc74cf7508',
                defaultMessage: 'Remove {title} from the list',
                description:
                    'Аттрибут aria-label кнопки удаления из списка продолженного просмотра',
            },
            {
                title,
            }
        ),
    continue_watching__remove_button__hint: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.selections.ecd2f08deef9ba5641882370969428a7',
            defaultMessage: 'You can hide the movie or TV series from "Continue Watching"',
            description: 'Текст подсказки кнопки удаления из списка продолженного просмотра',
        }),
    profile__menu_aria_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.ProfileMenu.36eb56accfc61ce24a7239b02ce3b911',

            defaultMessage: 'Profile menu',
            description: 'Текст кнопки меню профиля',
        }),
    profile__login_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.user-profile.bffe9a3c9a7e00ba00a11749e022d911',
            defaultMessage: 'Log in',
            description: 'Текст ссылки входа в профиль',
        }),
    plural_forms__day: (intl: IntlShape, { day }: { day: number }) =>
        intl.formatMessage(
            {
                id: 'common.ott.utils.681bfd02a524e2d68d0ebfd845a9db25',
                defaultMessage: '{day, plural, one {day} few {days} other {days}}',
                description: 'Множественное число для слова "день"',
            },
            { day }
        ),
    plural_forms__hour: (intl: IntlShape, { hour }: { hour: number }) =>
        intl.formatMessage(
            {
                id: 'common.ott.utils.9fc20c4a7980ca211cddf4637cb632bb',
                defaultMessage: '{hour, plural, one {hour} few {hours} other {hours}}',
                description: 'Множественное число для слова "час"',
            },
            { hour }
        ),
    episode_card__coming_soon: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.NotReleasedEpisodeCard.81151a1669ebd695e837f304a0d8ec79',
            defaultMessage: 'Coming soon',
            description: 'Текст на карточке серии, которая еще не вышла',
        }),
    episode_card__unavailable: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'components.Card.453e6aa38d87b28ccae545967c53004f',
            defaultMessage: 'Unavailable',
            description: 'Текст бейджа для недоступного эпизода',
        }),
    episode_card__title: (intl: IntlShape, episodeNumber: number) =>
        intl.formatMessage(
            {
                id: 'features.movie.728f6fa5b22043dfcae6ad27b35eeeda',
                defaultMessage: 'Episode {episodeNumber}',
                description: 'Название серии',
            },
            { episodeNumber }
        ),
    movie_set_planned_to_watch: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.b050aa81ebafe8bc9feea643749fd1ca',
            defaultMessage: 'Added to "Watch later"',
            description: 'Сообщение об успешном добавлении в раздел «Буду смотреть»',
        }),
    movie_remove_planned_to_watch: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.ffc98b4edaa5bf77b4613bf50fd3a4bc',
            defaultMessage: 'Removed from "Watch later"',
            description: 'Сообщение об успешном удалении из раздела «Буду смотреть»',
        }),
    movie_set_not_interested: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.037db5f3e4c56219ee1f013c84342890',
            defaultMessage: "We won't recommend similar videos",
            description: 'Сообщение об успешном добавлении в неинтересно',
        }),
    movie_remove_not_interested: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.movie.4f9d4a51d84ec887713a6626161125d3',
            defaultMessage: 'Removed from "Not interested"',
            description: 'Сообщение об успешном удалении из неинтересно',
        }),
    availability__published: (intl: IntlShape, { day, month }: { day: number; month: string }) =>
        intl.formatMessage(
            {
                id: 'common.ott.entities.filmPurchase.d8b153bc5e3639bb2391342fd5926efd',
                defaultMessage: 'Available until {month} {day} ',
                description: 'Текст с датой доступности эпизода',
            },
            { day, month }
        ),
    availability__disabled: (intl: IntlShape, { day, month }: { day: number; month: string }) =>
        intl.formatMessage(
            {
                id: 'common.ott.entities.filmPurchase.24f4db5a273db453abb0e3773e113cdf',
                defaultMessage: 'Unavailable from {month} {day} ',
                description: 'Текст с датой доступности эпизода',
            },
            { day, month }
        ),
    spinner__loading: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'common.ott.components.Spinner.16bfbf9c462762cf1cba4134ec53c504',
            defaultMessage: 'Loading',
            description:
                'Aria-label индикатора загрузки https://jing.yandex-team.ru/files/d-a-ragozin/2024-08-12_14-33-19.png',
        }),
    close_button__aria_label: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'ui.close-button.d3d2e617335f08df83599665eef8a418',
            defaultMessage: 'Close',
            description: 'Aria-label кнопки закрытия',
        }),
    back_to_home__title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.navigation.6957b0b6907b778b6f2977584b431bd2',
            defaultMessage: 'Back to Home',
            description: 'Текст ссылки на главную страницу на странице ошибки',
        }),
    contact_support__title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.support-chat.ad119d5ea30f6c26b58e0af5bc43c9fe',
            defaultMessage: 'Contact support',
            description: 'Текст ссылки на страницу поддержки',
        }),
};
